import theme from '@/theme';
import type { PaginationModel } from '@montugroup/design-system';
import { alpha, Box, Button } from '@mui/material';

export type Page = {
  page: number;
};
interface CursorPaginationProps {
  hasPrevPage: boolean;
  hasNextPage: boolean;
  handlePagination?: ({ page }: PaginationModel) => void;
}
const CursorPagination = ({ hasPrevPage, hasNextPage, handlePagination }: CursorPaginationProps) => {
  return (
    <Box display="flex" justifyContent="end">
      <Button
        variant="outlined"
        disableRipple={false}
        disabled={!hasPrevPage}
        onClick={() => handlePagination && handlePagination({ page: -1, pageSize: 20 })}
        sx={{
          borderRadius: '4px',
          color: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
          marginRight: '4px',
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.5)
          }
        }}
      >
        Previous
      </Button>
      <Button
        variant="outlined"
        disableRipple={false}
        disabled={!hasNextPage}
        onClick={() => handlePagination && handlePagination({ page: 1, pageSize: 20 })}
        sx={{
          borderRadius: '4px',
          color: theme.palette.primary.main,
          borderColor: theme.palette.primary.main,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.5)
          }
        }}
      >
        Next
      </Button>
    </Box>
  );
};

export default CursorPagination;
